import React from 'react';
import StatusColumn from 'src/common/utils/TableColumnIcons/StatusColumn';

export const StatusColumnFormat = (value) => {
	return (
		<>
			<StatusColumn
				value={value === 'A' ? 'Activa' : 'Inactiva'}
				color={value === 'A' ? 'primary' : 'grey'}
				light
			/>
		</>
	);
};
